"use client"

import React, { useState } from "react"
import { useAuth } from "../context/AuthContext"
import api from "../config/api"
import "./Profile.css"

const Profile = () => {
  const { user } = useAuth()
  const [formData, setFormData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  })
  const [message, setMessage] = useState("")
  const [error, setError] = useState("")

  const handlePasswordChange = async (e) => {
    e.preventDefault()
    setMessage("")
    setError("")

    if (formData.new_password !== formData.confirm_password) {
      setError("Yeni şifreler eşleşmiyor")
      return
    }

    try {
      await api.put(`/users/${user.id}`, {
        password: formData.new_password,
      })
      setMessage("Şifre başarıyla değiştirildi")
      setFormData({
        current_password: "",
        new_password: "",
        confirm_password: "",
      })
    } catch (error) {
      setError(error.response?.data?.message || "Şifre değiştirilemedi")
    }
  }

  return React.createElement(
    "div",
    { className: "profile-page" },
    React.createElement("h1", null, "Profilim"),
    React.createElement(
      "div",
      { className: "profile-grid" },
      React.createElement(
        "div",
        { className: "card" },
        React.createElement("h2", null, "Kişisel Bilgiler"),
        React.createElement(
          "div",
          { className: "info-grid" },
          React.createElement(
            "div",
            { className: "info-item" },
            React.createElement("strong", null, "Ad Soyad:"),
            React.createElement("span", null, `${user?.first_name} ${user?.last_name}`),
          ),
          React.createElement(
            "div",
            { className: "info-item" },
            React.createElement("strong", null, "Telefon:"),
            React.createElement("span", null, user?.phone),
          ),
          React.createElement(
            "div",
            { className: "info-item" },
            React.createElement("strong", null, "E-posta:"),
            React.createElement("span", null, user?.email || "-"),
          ),
          React.createElement(
            "div",
            { className: "info-item" },
            React.createElement("strong", null, "Departman:"),
            React.createElement("span", null, user?.department?.name || "-"),
          ),
          React.createElement(
            "div",
            { className: "info-item" },
            React.createElement("strong", null, "Rol:"),
            React.createElement("span", null, user?.role === "admin" ? "Admin" : "Personel"),
          ),
          React.createElement(
            "div",
            { className: "info-item" },
            React.createElement("strong", null, "Son Giriş:"),
            React.createElement(
              "span",
              null,
              user?.last_login_at ? new Date(user.last_login_at).toLocaleString("tr-TR") : "-",
            ),
          ),
        ),
      ),
      React.createElement(
        "div",
        { className: "card" },
        React.createElement("h2", null, "Şifre Değiştir"),
        message && React.createElement("div", { className: "success-message" }, message),
        error && React.createElement("div", { className: "error-message" }, error),
        React.createElement(
          "form",
          { onSubmit: handlePasswordChange },
          React.createElement(
            "div",
            { className: "input-group" },
            React.createElement("label", null, "Yeni Şifre"),
            React.createElement("input", {
              type: "password",
              value: formData.new_password,
              onChange: (e) => setFormData({ ...formData, new_password: e.target.value }),
              required: true,
              minLength: 6,
            }),
          ),
          React.createElement(
            "div",
            { className: "input-group" },
            React.createElement("label", null, "Yeni Şifre (Tekrar)"),
            React.createElement("input", {
              type: "password",
              value: formData.confirm_password,
              onChange: (e) => setFormData({ ...formData, confirm_password: e.target.value }),
              required: true,
              minLength: 6,
            }),
          ),
          React.createElement("button", { type: "submit", className: "btn btn-primary" }, "Şifreyi Değiştir"),
        ),
      ),
    ),
    user?.permissions &&
      user.permissions.length > 0 &&
      React.createElement(
        "div",
        { className: "card" },
        React.createElement("h2", null, "Yetkilerim"),
        React.createElement(
          "div",
          { className: "permissions-list" },
          user.permissions.map((perm) =>
            React.createElement("span", { key: perm.id, className: "badge badge-info" }, perm.name),
          ),
        ),
      ),
  )
}

export default Profile
